import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { signalerPage } from '../lib/mesure';

/**
 * Signale la page consultée à chaque changement d'adresse.
 *
 * Ne rend rien. Le back-office est exclu : ce sont les pages du commerçant,
 * pas celles de ses clients, et les compter fausserait la fréquentation.
 */
export default function MesureAudience() {
  const { pathname } = useLocation();
  const dernier = useRef(null);

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    // React appelle deux fois les effets en développement : sans cette
    // garde, chaque page compterait double dans les relevés locaux.
    if (dernier.current === pathname) return;
    dernier.current = pathname;
    signalerPage(pathname);
  }, [pathname]);

  return null;
}
